import { dispatch } from '@ngxs/store';
import { AppStateActions } from './app.actions';
import * as i0 from "@angular/core";
export let AppStateFacade = /*#__PURE__*/(() => {
  class AppStateFacade {
    constructor() {
      this.setConnectionError = dispatch(AppStateActions.SetConnectionError);
      this.setChunkError = dispatch(AppStateActions.SetChunkError);
    }
    static {
      this.ɵfac = function AppStateFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AppStateFacade)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AppStateFacade,
        factory: AppStateFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AppStateFacade;
})();